var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"builder-row"},[_c('p',{staticClass:"title-column"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":_vm.placeholder,"autofocus":""},domProps:{"value":_vm.url},on:{"input":function($event){return _vm.$emit('update:url', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }